<ng-container
  [ngTemplateOutlet]="routerLink() ? linkTemplate : divTemplate"
></ng-container>

<!-- If avatar can be clicked on as a link -->
<ng-template #linkTemplate>
  <a
    [routerLink]="routerLink()"
    class="tw-relative tw-flex tw-items-center tw-justify-center focus-visible:tw-outline-2"
    [ngClass]="avatarSizeClassMap[size()]"
  >
    <ng-container *ngTemplateOutlet="imageTemplate"></ng-container>
    <ng-container *ngTemplateOutlet="badgeTemplate"></ng-container>
  </a>
</ng-template>

<!-- If avatar is visual only -->
<ng-template #divTemplate>
  <div class="tw-relative" [ngClass]="avatarSizeClassMap[size()]">
    <ng-container *ngTemplateOutlet="imageTemplate"></ng-container>
    <ng-container *ngTemplateOutlet="badgeTemplate"></ng-container>
  </div>
</ng-template>

<!-- Avatar as an image -->
<ng-template #imageTemplate>
  <ng-container *ngIf="!useFallbackIcon(); else fallbackIconTemplate">
    <img
      [src]="src()"
      [alt]="altText()"
      class="tw-h-full tw-w-full tw-rounded-full tw-bg-neutral-100"
      (error)="imageDidNotLoad()"
    />
  </ng-container>
</ng-template>

<!-- Avatar using the fallback icon -->
<ng-template #fallbackIconTemplate>
  <div
    class="tw-relative tw-flex tw-items-center tw-justify-center tw-rounded-full tw-border tw-border-solid tw-border-neutral-300 tw-bg-neutral-100 tw-text-neutral-800"
    [ngClass]="avatarSizeClassMap[size()]"
  >
    <da-icon
      [icon]="config()?.fallbackIcon ?? 'user'"
      type="solid"
      class="tw-w-2/4"
      [ngClass]="{ 'tw-text-[10px]': size() === avatarSize.ExtraSmall }"
      [attr.aria-label]="altText()"
    ></da-icon>
  </div>
</ng-template>

<!-- Optional badge template-->
<ng-template #badgeTemplate>
  <ng-container
    *ngIf="
      badgeIcon() &&
      size() !== avatarSize.Small &&
      size() !== avatarSize.ExtraSmall
    "
  >
    <div
      class="tw-border-neutral-white tw-absolute tw-bottom-0 tw-right-0 tw-flex tw-h-4 tw-w-4 tw-items-center tw-justify-center tw-rounded-full tw-border tw-border-solid tw-bg-neutral-800 tw-text-white"
    >
      <da-icon
        [icon]="badgeIcon()"
        type="solid"
        class="tw-size-2.5 tw-text-[10px]"
        [attr.aria-label]="badgeAltText()"
      ></da-icon>
    </div>
  </ng-container>
</ng-template>
